import {
	Component,
	Input,
	ViewChild,
	ViewEncapsulation,
	Output,
	EventEmitter
} from '@angular/core';
import {
	KngGrid,
	KngGridState,
	GridDefinition,
	KngGridPagerCard
} from './definitions/kng-grid.interface';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';

@Component({
	selector: 'kng-grid',
	templateUrl: './template/kng-grid.component.html',
	styleUrls: ['./template/kng-grid.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class KngGridComponent implements KngGrid 
{
	totalArrayLength: number = 0;
	displayedColumns: string[] = [];
	value: string = '';
  @Output() action: EventEmitter<string> = new EventEmitter<string>();
  @Output() pageIndex: EventEmitter<number> = new EventEmitter<number>();
  @Output() sortColumn: EventEmitter<SortDirection> =
  	new EventEmitter<SortDirection>();
  dataSource: GridDefinition[] = [];

  columnsToDisplay: string[] = this.displayedColumns.slice();
  @Input() arrowIconGray: string = '/arrowLeft.svg';
  @Input() arrowIconOrange: string = '/arrowRightOrange.svg';
  @Input() isAccordion?: boolean;

  @Input() set state(value: KngGridState) 
  {
  	this.dataSource = value.grid;
  	this.displayedColumns = value.displayedColumns;
  	this.columnsToDisplay = this.displayedColumns.slice();
  	this.totalArrayLength = value.totalArrayLength;
  	this.pagedItems = value.grid;
  	this.isSortable = value.isSortable? value.isSortable : false;
  }
  
  isSortable = false;

  @ViewChild(MatSort)
  	sort!: MatSort;

  pager: KngGridPagerCard = {
  	totalPages: 1,
  	currentPage: 0,
  	endIndex: 0,
  	endPage: 0,
  	pageSize: 0,
  	startIndex: 0,
  	startPage: 0,
  	totalItems: 0
  };
  pageNumber: number = 1;
  pagedItems: GridDefinition[] = [];


  matsortColumn(value: Sort) 
  {
  	this.sortColumn.emit(value.direction);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onTableAction(e: any): void 
  {
  	this.action.emit(e);
  }
}
